module.exports = __webpack_public_path__ + "img/envelope-open-dollar.3ecf1820.svg";